import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';
import { DragAndDropIcon } from 'src/assets/icons/DragAndDropIcon';

export const EventName = styled('div', { label: 'EventName' })`
    text-align: center;
    font-size: 24px;
    margin: 16px 0;
    font-weight: ${fontWeight.bold};
`;

export const SelectHeader = styled('div', { label: 'SelectHeader' })`
    flex: 1 0 100%;
    font-size: 12px;
    color: ${mainColors.default.dark};
    margin: 0 0 5px 0;
`;

export const PickSelections = styled('div', { label: 'PickSelections' })``;

export const PickSingleSelections = styled('div', { label: 'PickSingleSelections' })`
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    padding: 4px 8px;
    margin-bottom: 8px;
    background-color: ${mainColors.grays.gray200};
`;

export const PickSelectionButton = styled('div', { label: 'PickSelectionButton' })`
    width: 20px;
    height: 20px;
    border-radius: 5px;
    background-color: ${mainColors.main.secondary};
    color: ${mainColors.default.light};
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-right: 8px;
`;

export const PickedSelectionWrapper = styled('div', { label: 'PickedSelectionWrapper' })`
    padding: 4px 8px;
    margin: 8px 0;
    background-color: ${mainColors.grays.gray200};
`;

export const MovableItemWrapper = styled('div', { label: 'MovableItemWrapper' })`
    outline: none;
    margin-top: 4px;
    :first-of-type {
        margin-top: 0;
    }
`;

export const DragAndDropIconWrapper = styled(DragAndDropIcon, { label: 'DragAndDropIconWrapper' })<{isDragged: boolean}>`
    width: 18px;
    align-self: center;
    cursor: ${({ isDragged }): string => isDragged ? 'grabbing' : 'grab'};
`;

export const ActionButtonsWrapper = styled('div', { label: 'ActionButtonsWrapper' })`
    display: flex;
`;
